const MATERIAL_SYMBOLS_CLASS = "material-symbols-ready";

export function ensureMaterialSymbolsReady(): void {
  const root = document.documentElement;
  if (root.classList.contains(MATERIAL_SYMBOLS_CLASS)) return;

  const markReady = () => {
    root.classList.add(MATERIAL_SYMBOLS_CLASS);
  };

  if (!document.fonts?.load) {
    markReady();
    return;
  }

  void document.fonts
    .load('24px "Material Symbols Outlined"')
    .then(markReady)
    .catch(markReady);

  window.setTimeout(markReady, 3000);
}
